module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "landfill.465d154f.jpg";